angular.module('unica_check.check_controllers', [])

.controller('CheckBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

});


